import React from 'react';
import { useTranslate } from '../../lib';

export default function Feedback({ data = [] }) {
    const { t } = useTranslate();

    if (!data || data.length === 0) {
        return (
            <div className="feedback-container p-4">
                <div className="mt-4 p-8 border-dashed border-2 border-gray-200 rounded text-center text-gray-400">
                    {t('reports.style.noData')}
                </div>
            </div>
        );
    }

    return (
        <div className="feedback-container p-2" style={{overflowY: 'scroll', maxHeight: 550}}>
            {data.map((item) => (
                <div
                    key={item.id}
                    className="p-4 bg-white rounded shadow-sm border border-gray-100"
                >
                    <div className="flex justify-between items-center mb-2">
                        <div className="text-sm text-gray-600">
                            {item.user}
                        </div>
                        <div className="text-xs text-gray-400 d-flex flex-column">
                            <span>{item.created_at?.substring(0, 19)}</span>
                        </div>
                    </div>

                    <div className="flex items-center mb-2">
                        {Array.from({ length: item.star }).map((_, i) => (
                            <span
                                key={i}
                                className={`text-lg ${
                                    i < item.star ? 'text-yellow-400' : 'text-gray-300'
                                }`}
                            >
                                ★
                            </span>
                        ))}
                    </div>

                    <div className="text-sm text-gray-700">
                        {item.comment || (
                            <span className="italic text-gray-400">
                                {t('common.noComments')}
                            </span>
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
}